import type { SpatiusAvatarConnectionStatus } from "@/types/spatius-avatar";
import type { AgentState } from "@livekit/components-react";
import type { ConversationState as AvatarSdkConversationState } from "@spatius/avatarkit";

export const SPATIUS_IDLE_RECOVERY_DELAY_MS = 1500;
export const SPATIUS_IDLE_RECOVERY_RECHECK_MS = 750;
export const SPATIUS_IDLE_RECOVERY_THROTTLE_MS = 10000;

type SpatiusConversationStateValue =
  | AvatarSdkConversationState
  | "idle"
  | "playing"
  | "paused"
  | null;

export function shouldRecoverIdleSpatiusAvatar({
  agentState,
  conversationState,
  status,
  viewerOwnsAudio,
}: {
  agentState: AgentState;
  conversationState: SpatiusConversationStateValue;
  status: SpatiusAvatarConnectionStatus;
  viewerOwnsAudio: boolean;
}) {
  // In the current web path, the Spatius viewer is video-only and the base
  // LiveKit room owns audible tutor playback. AvatarKit's conversationState is
  // tied to its own audio controller, so it can remain idle while video/animation
  // frames are rendering correctly. Only use this signal in a mode where the
  // viewer itself owns audio playback.
  if (!viewerOwnsAudio) {
    return false;
  }

  return agentState === "speaking" && status === "connected" && conversationState === "idle";
}

export function isSpatiusIdleRecoveryThrottled({
  lastRecoveryAtMs,
  nowMs,
  throttleMs = SPATIUS_IDLE_RECOVERY_THROTTLE_MS,
}: {
  lastRecoveryAtMs: number;
  nowMs: number;
  throttleMs?: number;
}) {
  return lastRecoveryAtMs > 0 && nowMs - lastRecoveryAtMs < throttleMs;
}
